import { render, staticRenderFns } from "./StudioPage.vue?vue&type=template&id=c614f3ae&"
import script from "./StudioPage.vue?vue&type=script&lang=js&"
export * from "./StudioPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports